/** Temps de travail : la saisie, les listes, le contrôle et la correction d'une saisie. */
import { lazy } from 'react';
import type { AppRoute } from '../../app/route-types.js';

const TimeEntryPage = lazy(() => import('./TimeEntryPage.js').then((m) => ({ default: m.TimeEntryPage })));
const TimeCorrectionPage = lazy(() => import('./TimeCorrectionPage.js').then((m) => ({ default: m.TimeCorrectionPage })));

// Saisir son temps demande `time.record_own`, comme l'API : sans lui, l'adresse mène à l'accueil.
export const timeRoutes: AppRoute[] = [
  { path: '/temps', element: <TimeEntryPage />, gate: { anyOf: ['time.record_own'] } },
  { path: '/temps/saisies/:id/corriger', element: <TimeCorrectionPage />, gate: { anyOf: ['time.record_own'] } },
];
